import { render } from "./HelixAccordion.vue?vue&type=template&id=01698d28"
import script from "./HelixAccordion.vue?vue&type=script&lang=js"
export * from "./HelixAccordion.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__